<template>
  <div class="mapManagement" :style="{ overflow: animation ? 'hidden' : '' }">
    <div class="header">
      <div class="header-tab">
        <div
          class="tab-item"
          :class="activeIndex === 1 ? 'active' : ''"
          @click="switchMap(1)"
        >
          <span>我的地图</span>
          <div class="line"></div>
        </div>
        <div
          class="tab-item"
          :class="activeIndex === 3 ? 'active' : ''"
          @click="switchMap(3)"
        >
          <span>我的分享</span>
          <div class="line"></div>
        </div>
        <div
          class="tab-item"
          :class="activeIndex === 2 ? 'active' : ''"
          @click="switchMap(2)"
        >
          <span>案例模板</span>
          <div class="line"></div>
        </div>
      </div>
      <el-input
        :placeholder="activeIndex === 3?'按分享名称搜索':'按地图名称搜索'"
        clearable
        prefix-icon="el-icon-search"
        class="searchInput"
        :maxlength="20"
        show-word-limit
        @input="searchMap"
        v-model="queryParamName"
      >
      </el-input>
    </div>
    <!-- 我的地图 -->
    <div class="main" v-show="activeIndex === 1">
      <transition
        name="el-fade-in-linear"
        @before-enter="animation = true"
        @after-leave="animation = false"
      >
        <div class="content" v-show="activeIndex === 1">
          <div
            class="box first"
            v-if="permissionLevel >= PermissionLevel.COMPILER"
          >
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="0"
              class="demo-ruleForm"
            >
              <el-form-item prop="name">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="地图名称（必填）"
                  :maxlength="20"
                  show-word-limit
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-select
                  v-model="ruleForm.areaId"
                  filterable
                  placeholder="请选择地图区域"
                  clearable
                >
                  <el-option
                    v-for="item in areaOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                    <span
                      style="font-size: 13px; float: left"
                      v-if="item.type === 'COMMON'"
                    >
                      <Icon
                        name="icon-quyu1"
                        style="opacity: 0.5; transform: translateY(5px)"
                      ></Icon>
                    </span>
                    <span
                      style="font-size: 13px; float: left"
                      v-if="item.type === 'FINAL'"
                    >
                      <Icon
                        name="icon-moxingyingyong1"
                        style="opacity: 0.5; transform: translateY(5px)"
                      ></Icon>
                    </span>
                    <span style="text-align: left">
                      <span>{{ item.name }}</span>
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input
                  class="form-input-long"
                  resize="none"
                  :rows="3"
                  maxlength="40"
                  show-word-limit
                  v-model="ruleForm.remark"
                  type="textarea"
                  placeholder="地图描述"
                >
                </el-input>
              </el-form-item>
            </el-form>
            <el-button type="primary" class="addMapBtn" @click="addMap"
              >新建地图</el-button
            >
          </div>
          <template v-if="mapList && mapList.length > 0">
            <div class="box" v-for="(item, index) in mapList" :key="index">
              <div class="earthBox">
                <div class="shade">
                  <el-button type="primary" @click="openMap(item, false)"
                    >打开地图</el-button
                  >
                </div>
              </div>
              <div class="center">
                <div class="title">
                  <el-tooltip
                    :content="item.name"
                    placement="top-start"
                    effect="light"
                    :open-delay="1000"
                    v-if="item.name.length > 11"
                  >
                    <span
                      ><img src="@/assets/images/mapicon.png" />{{
                        item.name
                      }}</span
                    >
                  </el-tooltip>
                  <span v-else
                    ><img src="@/assets/images/mapicon.png" />{{
                      item.name
                    }}</span
                  >
                  <span
                    class="nopublic"
                    :class="item.template ? 'publiced' : ''"
                    v-if="false"
                    ><span class="dot"></span
                    >{{ item.template ? "已发布" : "未发布" }}</span
                  >
                </div>
                <div class="time">
                  <i class="el-icon-time"></i
                  >{{ new Date(item.createTime).format("yyyy/MM/dd hh:mm:ss") }}
                </div>
              </div>
              <div class="bottom">
                <span>标记数：{{ item.markCount }}</span>
                <span class="icons">
                  <el-tooltip
                    content="复制"
                    placement="top"
                    effect="light"
                    :open-delay="1000"
                  >
                    <Icon
                      name="icon-copy-b"
                      @click="copyMap(item)"
                      :disabled="permissionLevel <= PermissionLevel.LOOKER"
                    ></Icon>
                  </el-tooltip>
                  <el-tooltip
                    content="创建分享"
                    placement="top"
                    effect="light"
                    :open-delay="1000"
                  >
                    <Icon
                      name="icon-share2"
                      @click="createShareMap(item, index)"
                    ></Icon>
                  </el-tooltip>
                  <el-tooltip
                    content="编辑"
                    placement="top"
                    effect="light"
                    :open-delay="1000"
                  >
                    <Icon
                      name="icon-edit"
                      @click="editMap(item, index)"
                      :disabled="permissionLevel <= PermissionLevel.LOOKER"
                    ></Icon>
                  </el-tooltip>
                  <el-tooltip
                    content="删除"
                    placement="top"
                    effect="light"
                    :open-delay="1000"
                  >
                    <Icon
                      name="icon-ashbin"
                      @click="deleteMap(item)"
                      :disabled="permissionLevel <= PermissionLevel.LOOKER"
                    ></Icon>
                  </el-tooltip>
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="isAdmin && !item.template"
                    :loading="loading===item.id"
                    :disabled="permissionLevel <= PermissionLevel.LOOKER"
                    @click="onPublicMap(item)"
                    >发布</el-button
                  >
                  <el-button
                    type="primary"
                    size="mini"
                    v-if="isAdmin && item.template"
                    @click="onPublicMap(item)"
                    :loading="loading===item.id"
                    :disabled="permissionLevel <= PermissionLevel.LOOKER"
                    >更新
                  </el-button>
                  <span class="dot red" v-if="isAdmin && item.template && item.updateFlag"></span>
                </span>
              </div>
              <div class="editForm" v-if="showEdit && showEditIndex === index">
                <el-form
                  :model="editForm"
                  :rules="editRules"
                  :ref="'editForm' + index"
                  label-width="0"
                  class="demo-ruleForm"
                >
                  <el-form-item prop="name">
                    <el-input
                      v-model="editForm.name"
                      placeholder="地图名称（必填）"
                      :maxlength="20"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="editForm.areaId"
                      filterable
                      placeholder="请选择地图区域"
                      clearable
                    >
                      <el-option
                        v-for="item in areaOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                        <span
                          style="font-size: 13px; float: left"
                          v-if="item.type === 'COMMON'"
                        >
                          <Icon
                            name="icon-quyu1"
                            style="opacity: 0.5; transform: translateY(5px)"
                          ></Icon>
                        </span>
                        <span
                          style="font-size: 13px; float: left"
                          v-if="item.type === 'FINAL'"
                        >
                          <Icon
                            name="icon-moxingyingyong1"
                            style="opacity: 0.5; transform: translateY(5px)"
                          ></Icon>
                        </span>
                        <span style="text-align: left">
                          <span>{{ item.name }}</span>
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      class="form-input-long"
                      resize="none"
                      :rows="3"
                      maxlength="40"
                      show-word-limit
                      v-model="editForm.remark"
                      type="textarea"
                      placeholder="地图描述"
                    >
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="btns">
                  <el-button
                    @click="
                      showEdit = false;
                      showEditIndex = -1;
                    "
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    @click="addEditMap('editForm' + index)"
                    >保存</el-button
                  >
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <Empty2 class="empty2"></Empty2>
          </template>
        </div>
      </transition>
    </div>

    <div class="main" v-show="activeIndex === 3">
      <transition
        name="el-fade-in-linear"
        @before-enter="animation = true"
        @after-leave="animation = false"
      >
        <div class="content" v-show="activeIndex === 3">
          <template v-if="shareMapList && shareMapList.length > 0">
            <div class="box" v-for="(item, index) in shareMapList" :key="index">
              <div class="earthBox">
                <div class="shade">
                  <el-button type="primary" @click="openShareMap(item, false)"
                    >打开分享</el-button
                  >
                </div>
              </div>
              <div class="center">
                <div class="title">
                  <el-tooltip
                    :content="item.name"
                    placement="top-start"
                    effect="light"
                    :open-delay="1000"
                    v-if="item.name && item.name.length > 11"
                  >
                    <span
                      ><img src="@/assets/images/mapicon.png" />{{
                        item.name
                      }}</span
                    >
                  </el-tooltip>
                  <span v-else
                    ><img src="@/assets/images/mapicon.png" />{{
                      item.name
                    }}</span
                  >
                </div>
                <div class="time">
                  <i class="el-icon-time"></i
                  >{{ new Date(item.createTime).format("yyyy/MM/dd hh:mm:ss") }}
                </div>
                <div class="switch">
                  <span class="open" v-if="item.switchs">开</span>
                  <span class="close" v-if="!item.switchs">关</span>
                  <el-switch
                    v-model="item.switchs"
                    active-color="#00A4F0"
                    :disabled="item.accessExpiredTime-item.createTime<=0"
                    inactive-color="rgba(255, 255, 255, 0.2)"
                    @change="onSwitchShare(item)"
                  >
                  </el-switch>
                </div>
              </div>
              <div class="bottom">
                <span>标记数：{{ item.markCount }}</span>
                <span class="icons">
                  <el-tooltip
                    content="详情"
                    placement="top"
                    effect="light"
                    :open-delay="1000"
                  >
                    <Icon
                      name="icon-share2"
                      @click="lookupShareMap(item, index)"
                    ></Icon>
                  </el-tooltip>
                  <el-tooltip
                    content="删除"
                    placement="top"
                    effect="light"
                    :open-delay="1000"
                  >
                    <Icon
                      name="icon-ashbin"
                      @click="deleteShareMap(item)"
                      :disabled="permissionLevel <= PermissionLevel.LOOKER"
                    ></Icon>
                  </el-tooltip>
                </span>
              </div>
              <div class="editForm" v-if="showEdit && showEditIndex === index">
                <el-form
                  :model="editForm"
                  :rules="editRules"
                  :ref="'editForm' + index"
                  label-width="0"
                  class="demo-ruleForm"
                >
                  <el-form-item prop="name">
                    <el-input
                      v-model="editForm.name"
                      placeholder="地图名称（必填）"
                      :maxlength="20"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-select
                      v-model="editForm.areaId"
                      filterable
                      placeholder="请选择地图区域"
                      clearable
                    >
                      <el-option
                        v-for="item in areaOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                        <span
                          style="font-size: 13px; float: left"
                          v-if="item.type === 'COMMON'"
                        >
                          <Icon
                            name="icon-quyu1"
                            style="opacity: 0.5; transform: translateY(5px)"
                          ></Icon>
                        </span>
                        <span
                          style="font-size: 13px; float: left"
                          v-if="item.type === 'FINAL'"
                        >
                          <Icon
                            name="icon-moxingyingyong1"
                            style="opacity: 0.5; transform: translateY(5px)"
                          ></Icon>
                        </span>
                        <span style="text-align: left">
                          <span>{{ item.name }}</span>
                        </span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-input
                      class="form-input-long"
                      resize="none"
                      :rows="3"
                      maxlength="40"
                      show-word-limit
                      v-model="editForm.remark"
                      type="textarea"
                      placeholder="地图描述"
                    >
                    </el-input>
                  </el-form-item>
                </el-form>
                <div class="btns">
                  <el-button
                    @click="
                      showEdit = false;
                      showEditIndex = -1;
                    "
                    >取消</el-button
                  >
                  <el-button
                    type="primary"
                    @click="addEditMap('editForm' + index)"
                    >保存</el-button
                  >
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <Empty2 class="empty2"></Empty2>
          </template>
        </div>
      </transition>
    </div>

    <div class="main" v-show="activeIndex === 2">
      <transition
        name="el-fade-in-linear"
        @before-enter="animation = true"
        @after-leave="animation = false"
      >
        <div class="content" v-show="activeIndex === 2">
          <template v-if="templateList && templateList.length > 0">
            <div class="box" v-for="(item, index) in templateList" :key="index">
              <div class="earthBox">
                <div class="shade">
                  <el-button type="primary" @click="openMap(item, true)"
                    >打开案例</el-button
                  >
                </div>
              </div>
              <div class="center">
                <div class="title">
                  <el-tooltip
                    :content="item.name"
                    placement="top-start"
                    effect="light"
                    :open-delay="1000"
                    v-if="item.name.length > 11"
                  >
                    <span
                      ><img src="@/assets/images/mapicon.png" />{{
                        item.name
                      }}</span
                    >
                  </el-tooltip>
                  <span v-else
                    ><img src="@/assets/images/mapicon.png" />{{
                      item.name
                    }}</span
                  >
                  <span></span>
                </div>
                <div class="time">
                  <i class="el-icon-time"></i
                  >{{ new Date(item.updateTime).format("yyyy/MM/dd hh:mm:ss") }}
                </div>
              </div>
              <div class="bottom">
                <span>标记数：{{ item.markCount }}</span>
                <span class="icons">
                  <el-tooltip
                    content="分享"
                    placement="top"
                    effect="light"
                    :open-delay="1000"
                  >
                    <Icon
                      name="icon-share2"
                      @click="shareTemplate(item, index)"
                    ></Icon>
                  </el-tooltip>
                  <el-button
                    size="mini"
                    v-if="isAdmin"
                    @click="onDelTemplate(item)"
                    >移除</el-button
                  >
                </span>
              </div>
            </div>
          </template>
          <template v-else>
            <Empty2 class="empty2"></Empty2>
          </template>
        </div>
      </transition>
    </div>

    <MapShareDialog
      ref="MapShareDialog"
      @openSettingDialog="openSettingDialog"
      @refresh="refresh"
    ></MapShareDialog>
    <TemplateShareDialog
      ref="TemplateShareDialog"
      @templateRefresh="templateRefresh"
    ></TemplateShareDialog>
    <SettingDialog ref="SettingDialog"></SettingDialog>
  </div>
</template>

<script>
import MapShareDialog from './components/MapShareDialog'
import TemplateShareDialog from './components/TemplateShareDialog'
import SettingDialog from './components/SettingDialog'
import { PermissionLevel } from '@/configs/constants'
import { mapGetters } from 'vuex'
import {
  getArealList,
  addMap,
  getMapPages,
  deleteMap,
  addEditMap,
  addTemplateMap,
  removeTemplateMap,
  getTemplateMap,
  getSharePage,
  deleteShare,
  updateShare,
  copyMap
} from '@/api/mapManagement'
// import _ from 'lodash'
export default {
  name: 'index',
  props: {},
  components: { MapShareDialog, TemplateShareDialog, SettingDialog },
  data () {
    return {
      teamEnable: true,
      animation: false,
      activeIndex: 1,
      keywords: '',
      ruleForm: {
        name: '',
        areaId: undefined,
        remark: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入地图名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入1~20个字符', trigger: 'blur' }
        ]
      },
      editForm: {
        name: '',
        areaId: undefined,
        remark: ''
      },
      editRules: {
        name: [
          { required: true, message: '请输入地图名称', trigger: 'blur' },
          { min: 1, max: 20, message: '请输入1~20个字符', trigger: 'blur' }
        ]
      },
      areaOptions: [],
      queryParamName: '', // 模糊查询地图名字
      queryParams1: {
        name: '',
        pageSize: 10000,
        pageNumber: 1
      },
      queryParams3: {
        name: '',
        pageSize: 10000,
        pageNumber: 1
      },
      queryParams2: {
        name: '',
        pageSize: 10000,
        pageNumber: 1
      },
      mapList: [],
      showEdit: false,
      showEditIndex: -1,
      timer: null,
      templateList: [],
      shareMapList: [],
      loading: undefined,
      PermissionLevel
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'permissionLevel'])
  },
  mounted () {
    this.getArealList()
    this.getMapPages()
    this.getTemplateMap()
    this.getShareMap()
    this.activeIndex = this.$route.params.isTemplate ? 2 : 1
  },
  methods: {
    // 切换地图菜单
    switchMap (index) {
      this.showEdit = false
      this.activeIndex = index
      this.queryParamName = ''
      this.queryParams1.name = ''
      this.queryParams3.name = ''
      this.queryParams2.name = ''
      if (index === 1) {
        this.getMapPages()
      } else if (index === 3) {
        this.getShareMap()
      } else {
        this.getTemplateMap()
      }
    },
    changeCascader (v) {
      if (v && v.length) {
        this.ruleForm.areaId = v[v.length - 1]
      }
    },
    // 新建地图
    addMap () {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          addMap(this.ruleForm)
            .then((res) => {
              if (res.code === 200) {
                this.$Message('success', res.msg)
                this.$refs.ruleForm.resetFields()
                this.ruleForm = this.$options.data().ruleForm
                this.getMapPages()
              }
            })
            .catch((e) => {
              if (e.response && e.response.status === 4000) {
                this.$Delete({
                  confirm: () => {
                    this.$router.push('/payManagement')
                  },
                  message: '当前地图数量已满, 是否立即升级团队'
                })
              }
            })
        }
      })
    },
    // 复制地图
    async copyMap (item) {
      const loading = this.$loading({ text: '地图复制中...' })
      try {
        await copyMap(item.id)
        // 重置地图列表
        this.getMapPages()
        this.$message.success()
      } catch (e) {
        if (e.response && e.response.status === 4000) {
          this.$Delete({
            confirm: () => {
              this.$router.push('/payManagement')
            },
            message: '当前地图数量已满, 是否立即升级团队'
          })
        }
      } finally {
        loading.close()
      }
    },
    // 保存地图编辑
    addEditMap (formName) {
      this.$refs[formName][0].validate((valid) => {
        if (valid) {
          addEditMap(this.editForm).then((res) => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              this.$refs[formName][0].resetFields()
              this.editForm = this.$options.data().editForm
              this.getMapPages()
              this.showEditIndex = -1
              this.showEdit = false
            }
          })
        } else {
        }
      })
    },
    // 获取区域列表
    getArealList () {
      getArealList().then((res) => {
        if (res.code === 200) {
          this.areaOptions = []
          this.areaOptions = res.data
        }
      })
    },
    // 查询地图分页
    getMapPages () {
      getMapPages(this.queryParams1).then((res) => {
        if (res.code === 200) {
          this.mapList = res.data.records
        }
      })
    },
    deleteMap (item) {
      this.$Delete({
        confirm: () => {
          deleteMap({ ids: [item.id] }).then((res) => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              // this.getMapPages()
              // 刷新地图数据和分享数据
              this.refresh()
              // 刷新案例模板数据
              this.templateRefresh()
            }
          })
        },
        cancel: () => {}
      })
    },
    editMap (item, index) {
      this.editForm = JSON.parse(JSON.stringify(item))
      this.showEdit = true
      this.showEditIndex = index
    },
    searchMap () {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(() => {
        if (this.activeIndex === 1) {
          this.queryParams1.name = this.queryParamName
          this.getMapPages()
        } else if (this.activeIndex === 3) {
          this.queryParams3.name = this.queryParamName
          this.getShareMap()
        } else {
          this.queryParams2.name = this.queryParamName
          this.getTemplateMap()
        }
      }, 500)
    },
    openMap (item, isTemplate) {
      if (isTemplate) {
        // this.$router.push({ path: '/operatingPlatform/marker', query: { mapId: item.id, areaId: item.areaId, template: isTemplate } })
        window.open(`/operatingPlatform/marker?mapId=${item.id}&template=true`)
      } else {
        this.$router.push({
          path: '/operatingPlatform/marker',
          query: { mapId: item.id, areaId: item.areaId }
        })
      }
    },
    openShareMap (item) {
      window.open(`/share/${item.nonceStr}`, '_blankd')
    },
    // 发布模板
    async onPublicMap (item) {
      this.loading = item.id
      try {
        const res = await addTemplateMap({
          id: item.id
        })
        if (res.code === 200) {
          this.$message.success('发布模板成功！')
          this.getTemplateMap()
          this.getMapPages()
        }
      } finally {
        this.loading = undefined
      }
    },
    onDelTemplate (item) {
      this.$Delete({
        message: '您确定移除该案例模板嘛？',
        confirm: () => {
          removeTemplateMap({
            id: item.id
          }).then((res) => {
            if (res.code === 200) {
              this.$message.success('移除模板成功！')
              this.getTemplateMap()
              this.getMapPages()
            }
          })
        },
        cancel: () => {}
      })
    },
    // 获取模板地图
    getTemplateMap () {
      getTemplateMap(this.queryParams2).then((res) => {
        if (res.code === 200) {
          this.templateList = res.data.records
        }
      })
    },
    // 获取分享地图
    getShareMap () {
      getSharePage(this.queryParams3).then((res) => {
        if (res.code === 200) {
          this.shareMapList = res.data.records
        }
      })
    },
    // 分享地图
    createShareMap (item, index) {
      this.$refs.MapShareDialog.open({
        mapId: item.id,
        dialogType: 0
      })
    },
    lookupShareMap (item) {
      this.$refs.MapShareDialog.open({
        ...item,
        shareId: item.id,
        dialogType: 1
      })
    },
    deleteShareMap (item) {
      this.$Delete({
        confirm: () => {
          deleteShare({ id: item.id }).then((res) => {
            if (res.code === 200) {
              this.$Message('success', res.msg)
              // this.getMapPages()
              // 刷新地图数据和分享数据
              this.refresh()
            }
          })
        },
        cancel: () => {}
      })
    },
    async onSwitchShare (item) {
      await updateShare({
        'id': item.id,
        'name': item.name,
        'switchs': item.switchs
      })
    },
    // 分享案例模板
    shareTemplate (item, index) {
      this.$refs.TemplateShareDialog.open(
        item.id,
        item.templateShare,
        item.templateShareNoncestr
      )
    },
    // 高级设置
    openSettingDialog (shareId, mapId) {
      this.$refs.SettingDialog.open(shareId, mapId)
    },
    refresh () {
      this.getMapPages()
      this.getShareMap()
    },
    templateRefresh () {
      this.getTemplateMap()
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.mapManagement {
  background-color: #18191a;
  width: 100%;
  height: 100%;
  overflow: hidden;
  box-sizing: border-box;
  padding: 30px 170px 30px 170px;
  overflow-y: auto;
  .header {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 30px;
    .header-tab {
      display: flex;
      .tab-item {
        margin-right: 40px;
        cursor: pointer;
        span {
          font-size: 20px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #ffffff;
          opacity: 0.4;
        }
        .line {
          width: 40px;
          height: 4px;
          background: #00a4f0;
          border-radius: 2px;
          margin: 4px auto;
          opacity: 0;
        }
        &.active {
          span {
            opacity: 1;
          }
          .line {
            opacity: 1;
          }
        }
      }
    }
    .searchInput {
      width: 397px;
      height: 40px;
      .el-input__inner {
        height: 40px;
        border-radius: 20px;
        width: 397px;
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
  .main {
    width: 105%;
    height: calc(100% - 70px);
    /*overflow-y: auto;*/
    text-align: left;
    .content {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      .el-textarea .el-input__count {
        background-color: transparent !important;
      }
      .box {
        display: inline-block;
        width: 300px;
        height: 280px;
        background: #272829;
        box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        margin-right: 20px;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 8px;
        position: relative;
        &.first {
          padding: 16px;
          padding-bottom: 20px;
          box-sizing: border-box;
          .el-form-item {
            margin-bottom: 18px;
          }
          .addMapBtn {
            width: 160px;
            height: 32px;
            background: #00a4f0;
            border-radius: 4px;
            margin: 0 auto;
            display: block;
          }
        }
        .earthBox {
          width: 284px;
          height: 160px;
          border-radius: 8px;
          margin: 0 auto;
          background-image: url("./images/earth.png");
          background-repeat: no-repeat;
          background-size: cover;
          .shade {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: all 0.3s;
            border-radius: 8px;
            &:hover {
              opacity: 1;
              background: rgba(0, 0, 0, 0.6);
            }
          }
        }
        .center {
          margin-top: 15px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          padding-bottom: 10px;
          padding-left: 7px;
          .title {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 5px;
            margin-bottom: 5px;
            .nopublic {
              font-size: 12px !important;
              color: #999 !important;
            }
            > span:first-child {
              font-size: 16px;
              font-family: Source Han Sans SC;
              font-weight: 400;
              color: #ffffff;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              width: 190px;
            }
            > span:last-child {
              font-size: 16px;
              font-family: Source Han Sans SC;
              font-weight: 400;
              color: white;
            }
          }
          .time {
            font-size: 12px;
            font-family: Source Han Sans SC;
            font-weight: 400;
            color: #666666;
            i {
              margin-right: 8px;
            }
          }
        }
        .bottom {
          padding: 0 7px;
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 400;
          color: #999999;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 5px;
          .icons {
            display: flex;
            // width: 100px;
            justify-content: space-between;
            svg {
              color: #999999;
            }
          }
          .el-button {
            padding: -0 10px !important;
            height: 24px;
            margin-left: 7px;
          }
        }
        .editForm {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          padding: 16px;
          padding-bottom: 20px;
          box-sizing: border-box;
          background-color: #272829;
          border-radius: 10px;
          .el-form-item {
            margin-bottom: 18px;
          }
          .btns {
            text-align: center;
            > button {
              width: 80px;
            }
          }
        }
      }
      .dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #666666;
        border-radius: 50%;
        transform: translate(-6px, -2px);
        &.red {
          position: absolute;
          right: 5px;
          background: #f54949;
          box-shadow: 0 0 6px #f54949;
          width: 8px;
          height: 8px;
          // bottom: 23px;
        }
      }
      .publiced {
        .dot {
          background: #00a4f0;
          box-shadow: 0 0 6px #00a4f0;
        }
        color: #fff !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.empty2 {
  position: absolute;
  top: 30%;
  left: 0;
  right: 0;
}
.switch {
  position: absolute;
  right: 20px;
  bottom: 47px;
  .open {
    font-size: 12px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #ffffff;
    display: inline-block;
    left: 7px;
    top: 1px;
    z-index: 1000;
    position: absolute;
    pointer-events: none;
  }
  .close {
    font-size: 12px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #ffffff;
    display: inline-block;
    right: 7px;
    top: 1px;
    position: absolute;
  }
}
</style>
